import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from '../locales/en/common.json';
import authEn from '../locales/en/auth.json';
import dashboardEn from '../locales/en/dashboard.json';
import procurementEn from '../locales/en/procurement.json';
import inventoryEn from '../locales/en/inventory.json';
import settingsEn from '../locales/en/settings.json';
import validationEn from '../locales/en/validation.json';
import landingEn from '../locales/en/landing.json';
import pricingEn from '../locales/en/pricing.json';

import commonEl from '../locales/el/common.json';
import authEl from '../locales/el/auth.json';
import dashboardEl from '../locales/el/dashboard.json';
import procurementEl from '../locales/el/procurement.json';
import inventoryEl from '../locales/el/inventory.json';
import settingsEl from '../locales/el/settings.json';
import validationEl from '../locales/el/validation.json';
import landingEl from '../locales/el/landing.json';
import pricingEl from '../locales/el/pricing.json';

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    procurement: procurementEn,
    inventory: inventoryEn,
    settings: settingsEn,
    validation: validationEn,
    landing: landingEn,
    pricing: pricingEn,
  },
  el: {
    common: commonEl,
    auth: authEl,
    dashboard: dashboardEl,
    procurement: procurementEl,
    inventory: inventoryEl,
    settings: settingsEl,
    validation: validationEl,
    landing: landingEl,
    pricing: pricingEl,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'procurement', 'inventory', 'settings', 'validation', 'landing', 'pricing'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
